import styled from "styled-components";

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
  text-transform: capitalize;
  background-color: ${(props) => {
    switch (props.status) {
      case "complete":
        return "#DFF6DD";
      case "ongoing":
        return "#FFF4CC";
      case "new":
        return "#FFE5E5";
      case "shipped":
        return "#d8fffe";
      default:
        return "#E0E0E0";
    }
  }};
  color: ${(props) => {
    switch (props.status) {
      case "complete":
        return "#27AE60";
      case "ongoing":
        return "#b28e17";
      case "new":
        return "#EB5757";
      case "shipped":
        return "#2f97d3";
      default:
        return "#333";
    }
  }};
  /* border-color: ${(props) => {
    switch (props.status) {
      case "Complete":
        return "#27AE60";
      case "Ongoing":
        return "#F2C94C";
      case "Incomplete":
        return "#EB5757";
      case "Overdue":
        return "#D32F2F";
      default:
        return "#333";
    }
  }}; */
`;

const StatusDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: currentColor;
`;

const StatusWrapper = ({ status }) => {
  return (
    <Wrapper status={status}>
      <StatusDot />
      {status}
    </Wrapper>
  );
};

export default StatusWrapper;
